// import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  // AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';

function ImagePreview({ closeModal, open, data: { imageUrl } = {} }) {
  function close() {
    closeModal();
  }
  return (
    <AppModal open={open} closeModal={close}>
      <AppModalHeader></AppModalHeader>
      <AppModalBody style={{ minHeight: '90vh' }}>
        <div>
          <img
            className="w-100 h-100"
            src={imageUrl || 'https://picsum.photos/300/400'}
            alt="enlarged version for preview"
            style={{ border: '1px solid #de6cef', objectFit: 'contain' }}
          />
        </div>
      </AppModalBody>
      {/* <AppModalFooter></AppModalFooter> */}
    </AppModal>
  );
}

ImagePreview.defaultProps = {
  closeModal: () => {},
  handleConfirmation: () => {},
};

export default ImagePreview;
